export default "__VITE_ASSET___VnfIFL___"